export const prepareManifest = m => (m instanceof Array ? m : typeof m === 'string' ? {url: m, type: 'manifest'} : m);
